<template>
  <n-popover
    v-if="props.isPopoverMode"
    v-model:show="isPopoverShown"
    trigger="click"
    :show-arrow="false"
    :z-index="zIndex.navbarPopover"
    placement="bottom-end"
  >
    <template #trigger>
      <etg-button v-bind="downloadAppBtnProps">{{ $t('home.download_app.button') }}</etg-button>
    </template>
    <template #default>
      <div class="line-button-popup w-110 max-w-90dvw">
        <div class="header flex justify-between items-center gap-3 p-5 pb-2">
          <p class="title text-lg font-500">{{ $t('home.download_app.title') }}</p>
          <etg-button type="icon" icon="cancel" class="text-black-50" @click="hidePopover" />
        </div>
        <div class="content flex flex-col justify-between items-center p-5 pb-0 gap-5">
          <div class="download-content flex justify-between items-center gap-3">
            <QrCode :value="unifiedLink" :size="106" />
            <div class="flex flex-col gap-5">
              <p class="text-red-50 text-lg">
                <trans i18n-key="home.download_app.content" :components="downloadAppContentTransComponents" />
              </p>
              <div class="app-group flex items-center gap-6px">
                <template v-for="item in appIcons" :key="item.name">
                  <a :href="item.href" target="_blank">
                    <etg-img class="text-red-50 w-130px" :src="item.src" />
                  </a>
                </template>
              </div>
            </div>
          </div>
          <div class="decoration-image">
            <etg-img src="@/assets/images/marketing/app-download-gift-box.svg" />
          </div>
        </div>
      </div>
    </template>
  </n-popover>
  <div v-else class="app-group flex items-center gap-3">
    <a v-for="item in appIcons" :key="item.name" :href="item.href" target="_blank">
      <etg-img class="text-red-50 w-138px md:w-130px" :src="item.src" />
    </a>
  </div>
</template>

<script lang="ts" setup>
import { NPopover } from 'naive-ui'
import QrCode from 'qrcode.vue'

import { zIndex } from '@/theme.config'

interface Props {
  isPopoverMode?: boolean
}

const props = withDefaults(defineProps<Props>(), { isPopoverMode: false })

defineOptions({ inheritAttrs: false })

const attrs = useAttrs()
const { appIcons, unifiedLink } = useDownloadLinks()

const isPopoverShown = ref(false)

const downloadAppContentTransComponents = computed(() => ({
  b: { tag: 'b' },
}))
const downloadAppBtnProps = computed(() => ({
  icon: 'download-app' as const,
  bordered: true,
  truncateText: true,
  textClass: 'text-base',
  ...attrs,
  class: ['ring-yellow-50', attrs.class],
}))

function hidePopover() {
  isPopoverShown.value = false
}
</script>
